// extracted by mini-css-extract-plugin
export default {"button":"GoUpButton_button__MeQrH","over_btn":"GoUpButton_over_btn__H0N78","no_btn":"GoUpButton_no_btn__2ulXq","show":"GoUpButton_show__z9Et8","showAni":"GoUpButton_showAni__zlbd0"};